export enum YogaType {
    Classic = 'classic',
    ChairYoga = 'chair_yoga',
    WallPilates = 'wall_pilates',
    SofaYoga = 'sofa_yoga',
    SomaticYoga = 'somatic_yoga',
}

export enum YogaInstructor {
    Anke = 'anke',
    John = 'john',
}

export enum WorkoutFocus {
    Balance = 'balance',
    Strength = 'strength',
    Flexibility = 'flexibility',
}

export enum PlanType {
    Standard = 'standard',
    ShortWorkoutPlan = 'short_workout_plan',
}
